// import { Box, Chip, Fade, Grid, Typography } from "@mui/material";
// import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
// import React, { FC } from "react";

// import CircularProgress from '@mui/material/CircularProgress';
// import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
// import { IDropableItemData } from "@websential/cosmic-v20";
// import InboxRoundedIcon from "@mui/icons-material/InboxRounded";
// import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
// import { sortDDLByLabel } from "../../../common/Common";

// export interface IStatutoryHolidayEligibilityPanel {
// 	firstList: {
// 		droppableId: string;
// 		elements: IDropableItemData[];
// 		testId: String;
// 	};
// 	secondList: {
// 		droppableId: string;
// 		elements: IDropableItemData[];
// 		testId: String;
// 	};
// 	onDragEnd: (result: any, _provided: any) => void;
// }

// export const StatutoryHolidayEligibilityPanel: FC<
// 	IStatutoryHolidayEligibilityPanel
// > = ({ firstList, secondList, onDragEnd }) => {
// 	return (
// 		<Box sx={{ p: 2 }}>
// 			<Box sx={{ mt: 3 }}>
// 				<DragDropContext onDragEnd={onDragEnd}>
// 					<Grid container spacing={2}>
// 						{/* Eligible Employee(s) */}
// 						<Grid size={{ xs: 12, md: 6 }}>
// 							<Typography
// 								variant="h6"
// 								sx={{
// 									display: "flex",
// 									alignItems: "center",
// 									mb: 2,
// 								}}
// 							>
// 								Eligible Employee(s)
// 								<Box
// 									component="span"
// 									sx={{
// 										ml: 1,
// 										px: 1.5,
// 										py: 0.2,
// 										bgcolor: "primary.main",
// 										color: "#fff",
// 										borderRadius: "100%",
// 										fontSize: "0.8rem",
// 									}}
// 								>
// 									{firstList.elements.length}
// 								</Box>
// 							</Typography>

// 							<Droppable droppableId={firstList.droppableId}>
// 								{(provided) => (
// 									<Box
// 										ref={provided.innerRef}
// 										{...provided.droppableProps}
// 										sx={{
// 											minHeight: "300px",
// 											border: "1px solid #ddd",
// 											borderRadius: 2,
// 											p: 1,
// 											bgcolor: "#f9f9f9",
// 											maxHeight: "400px",
// 											overflowY: "auto",
// 										}}
// 									>
// 										{firstList.elements.map((item: any, index: any) => (
// 											<Draggable
// 												key={item.id}
// 												draggableId={item.id}
// 												index={index}
// 											>
// 												{(provided) => (
// 													<Box
// 														ref={provided.innerRef}
// 														{...provided.draggableProps}
// 														{...provided.dragHandleProps}
// 														sx={{
// 															bgcolor: "#fff",
// 															mb: 1,
// 															p: 1.5,
// 															borderRadius: 1,
// 															border: "1px solid #ccc",
// 															cursor: "grab",
// 															"&:hover": {
// 																boxShadow: 1,
// 															},
// 														}}
// 													>
// 														{item.text}
// 													</Box>
// 												)}
// 											</Draggable>
// 										))}
// 										{provided.placeholder}
// 									</Box>
// 								)}
// 							</Droppable>
// 						</Grid>

// 						{/* Ineligible Employee(s) */}
// 						<Grid size={{ xs: 12, md: 6 }}>
// 							<Typography
// 								variant="h6"
// 								sx={{
// 									display: "flex",
// 									alignItems: "center",
// 									mb: 2,
// 								}}
// 							>
// 								Ineligible Employee(s)
// 								<Box
// 									component="span"
// 									sx={{
// 										ml: 1,
// 										px: 1.5,
// 										py: 0.2,
// 										bgcolor: "primary.main",
// 										color: "#fff",
// 										borderRadius: "50%",
// 										fontSize: "0.8rem",
// 									}}
// 								>
// 									{secondList.elements.length}
// 								</Box>
// 							</Typography>

// 							<Droppable droppableId={secondList.droppableId}>
// 								{(provided) => (
// 									<Box
// 										ref={provided.innerRef}
// 										{...provided.droppableProps}
// 										sx={{
// 											minHeight: "300px",
// 											border: "1px solid #ddd",
// 											borderRadius: 2,
// 											p: 1,
// 											bgcolor: "#f9f9f9",
// 											maxHeight: "400px",
// 											overflowY: "auto",
// 										}}
// 									>
// 										{secondList.elements.map((item: any, index: any) => (
// 											<Draggable
// 												key={item.id}
// 												draggableId={item.id}
// 												index={index}
// 											>
// 												{(provided) => (
// 													<Box
// 														ref={provided.innerRef}
// 														{...provided.draggableProps}
// 														{...provided.dragHandleProps}
// 														sx={{
// 															bgcolor: "#fff",
// 															mb: 1,
// 															p: 1.5,
// 															borderRadius: 1,
// 															border: "1px solid #ccc",
// 															cursor: "grab",
// 															"&:hover": {
// 																boxShadow: 1,
// 															},
// 														}}
// 													>
// 														{item.text}
// 													</Box>
// 												)}
// 											</Draggable>
// 										))}
// 										{provided.placeholder}
// 									</Box>
// 								)}
// 							</Droppable>
// 						</Grid>
// 					</Grid>
// 				</DragDropContext>
// 			</Box>
// 		</Box>
// 	);
// };




// export interface IDNDList {
// 	droppableId: string;
// 	elements: IDropableItemData[];
// }

// export interface IStatutoryHolidayEligibilityPanel {
// 	firstList: IDNDList;
// 	secondList: IDNDList;
// 	onDragEnd: (result: any) => void;
// 	onDragStart?: (start: any) => void;
// 	selectedIds: string[];
// 	onItemClick: (
// 		e: React.MouseEvent,
// 		droppableId: string,
// 		itemId: string,
// 		index: number
// 	) => void;
// 	isLoading: boolean
// }

// const ACCENT = "#0091b3"; // panel accent — swap for theme.palette.primary.main if preferred

// const renderEmptyState = () => (
// 	<Box
// 		sx={{
// 			display: "flex",
// 			flexDirection: "column",
// 			alignItems: "center",
// 			justifyContent: "center",
// 			height: "100%",
// 			minHeight: "260px",
// 			color: "#a3a7b7",
// 			gap: 1,
// 		}}
// 	>
// 		<InboxRoundedIcon sx={{ fontSize: 34, opacity: 0.5 }} />
// 		<Typography variant="body2" sx={{ fontWeight: 500 }}>
// 			No employees here
// 		</Typography>
// 		<Typography variant="caption" sx={{ opacity: 0.8 }}>
// 			Drag someone in, or select on the other side
// 		</Typography>
// 	</Box>
// );

// const renderList = (
// 	list: IDNDList,
// 	title: string,
// 	selectedIds: string[],
// 	onItemClick: IStatutoryHolidayEligibilityPanel["onItemClick"],
// 	isLoading: boolean
// ) => (
// 	<Grid size={{ xs: 12, md: 6 }}>
// 		<Box
// 			sx={{
// 				display: "flex",
// 				alignItems: "center",
// 				justifyContent: "space-between",
// 				mb: 1.5,
// 			}}
// 		>

// 			<Typography
// 				variant="subtitle1"
// 				sx={{
// 					display: "flex",
// 					alignItems: "center",
// 					gap: 1,
// 					fontWeight: 600,
// 					letterSpacing: 0.2,
// 					color: "#20232b",
// 				}}
// 			>
// 				{title}
// 				{isLoading ?
// 					<CircularProgress sx={{ width: "20px!important", height: "20px!important", "& .MuiCircularProgress-svg": { width: "20px", height: "20px" } }} /> :
// 					<Chip
// 						label={list.elements.length}
// 						size="small"
// 						sx={{
// 							height: 20,
// 							fontSize: "0.72rem",
// 							fontWeight: 700,
// 							bgcolor: `${ACCENT}14`,
// 							color: ACCENT,
// 						}}
// 					/>}
// 			</Typography>
// 		</Box>

// 		<Droppable droppableId={list.droppableId}>
// 			{(provided, droppableSnapshot) => (
// 				<Box
// 					ref={provided.innerRef}
// 					{...provided.droppableProps}
// 					sx={{
// 						minHeight: "320px",
// 						maxHeight: "420px",
// 						overflowY: "auto",
// 						borderRadius: 3,
// 						p: 1.25,
// 						border: "1.5px solid",
// 						borderColor: droppableSnapshot.isDraggingOver
// 							? ACCENT
// 							: "#e6e8f0",
// 						bgcolor: droppableSnapshot.isDraggingOver
// 							? `${ACCENT}0A`
// 							: "#fafbfc",
// 						transition:
// 							"border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease",
// 						boxShadow: droppableSnapshot.isDraggingOver
// 							? `inset 0 0 0 1px ${ACCENT}33`
// 							: "none",
// 						"&::-webkit-scrollbar": { width: 6 },
// 						"&::-webkit-scrollbar-thumb": {
// 							bgcolor: "#d7dae3",
// 							borderRadius: 3,
// 						},
// 					}}
// 				>
// 					{list.elements.length === 0 && !droppableSnapshot.isDraggingOver
// 						? renderEmptyState()
// 						: list.elements.map((item: any, index: number) => {
// 							const isSelected = selectedIds.includes(item.id);
// 							return (
// 								<Draggable key={item.id} draggableId={item.id} index={index}>
// 									{(dragProvided, dragSnapshot) => (
// 										<Box
// 											ref={dragProvided.innerRef}
// 											{...dragProvided.draggableProps}
// 											{...dragProvided.dragHandleProps}
// 											onClick={(e) =>
// 												onItemClick(e, list.droppableId, item.id, index)
// 											}
// 											sx={{
// 												position: "relative",
// 												display: "flex",
// 												alignItems: "center",
// 												gap: 1,
// 												mb: 1,
// 												px: 1.25,
// 												py: 1,
// 												borderRadius: 2.5,
// 												cursor: dragSnapshot.isDragging ? "grabbing" : "grab",
// 												userSelect: "none",
// 												bgcolor: isSelected ? ACCENT : "#fff",
// 												color: isSelected ? "#fff" : "#2a2d38",
// 												border: "1px solid",
// 												borderColor: isSelected
// 													? ACCENT
// 													: dragSnapshot.isDragging
// 														? ACCENT
// 														: "#e9ebf1",
// 												boxShadow: dragSnapshot.isDragging
// 													? "0 12px 24px -8px rgba(91,95,239,0.35), 0 2px 6px rgba(0,0,0,0.08)"
// 													: isSelected
// 														? "0 1px 4px rgba(91,95,239,0.25)"
// 														: "0 1px 2px rgba(16,24,40,0.04)",
// 												transform: dragSnapshot.isDragging
// 													? "scale(1.03) rotate(-1deg)"
// 													: "scale(1)",
// 												transition: dragSnapshot.isDragging
// 													? "none" // no transition while actively dragging — must track cursor 1:1
// 													: "background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease",
// 												"&:hover": {
// 													borderColor: isSelected ? ACCENT : "#c7cbe0",
// 													boxShadow: dragSnapshot.isDragging
// 														? undefined
// 														: "0 2px 8px rgba(16,24,40,0.08)",
// 												},
// 											}}
// 										>
// 											<DragIndicatorRoundedIcon
// 												sx={{
// 													fontSize: 18,
// 													opacity: isSelected ? 0.85 : 0.35,
// 													flexShrink: 0,
// 												}}
// 											/>
// 											<Box
// 												sx={{
// 													width: 26,
// 													height: 26,
// 													borderRadius: "50%",
// 													display: "flex",
// 													alignItems: "center",
// 													justifyContent: "center",
// 													flexShrink: 0,
// 													bgcolor: isSelected
// 														? "rgba(255,255,255,0.2)"
// 														: `${ACCENT}12`,
// 													color: isSelected ? "#fff" : ACCENT,
// 												}}
// 											>
// 												<PersonRoundedIcon sx={{ fontSize: 15 }} />
// 											</Box>
// 											<Typography
// 												variant="body2"
// 												sx={{
// 													fontWeight: isSelected ? 600 : 500,
// 													flexGrow: 1,
// 													whiteSpace: "nowrap",
// 													overflow: "hidden",
// 													textOverflow: "ellipsis",
// 												}}
// 											>
// 												{item.text}
// 											</Typography>

// 											{dragSnapshot.isDragging &&
// 												isSelected &&
// 												selectedIds.length > 1 && (
// 													<Box
// 														sx={{
// 															position: "absolute",
// 															top: -8,
// 															right: -8,
// 															bgcolor: "#e14444",
// 															color: "#fff",
// 															borderRadius: "50%",
// 															width: 22,
// 															height: 22,
// 															fontSize: "0.7rem",
// 															fontWeight: 700,
// 															display: "flex",
// 															alignItems: "center",
// 															justifyContent: "center",
// 															boxShadow: "0 2px 6px rgba(225,68,68,0.4)",
// 														}}
// 													>
// 														{selectedIds.length}
// 													</Box>
// 												)}
// 										</Box>
// 									)}
// 								</Draggable>
// 							);
// 						})}
// 					{provided.placeholder}
// 				</Box>
// 			)}
// 		</Droppable>
// 	</Grid>
// );

// export const StatutoryHolidayEligibilityPanel: FC<IStatutoryHolidayEligibilityPanel> = ({
// 	firstList,
// 	secondList,
// 	onDragEnd,
// 	onDragStart,
// 	selectedIds,
// 	onItemClick,
// 	isLoading
// }) => {
// 	return (
// 		<Box sx={{ p: { xs: 1.5, md: 2.5 } }}>
// 			{selectedIds.length > 0 && (
// 				<Fade in>
// 					<Box
// 						sx={{
// 							display: "flex",
// 							alignItems: "center",
// 							gap: 1,
// 							mb: 2,
// 							px: 1.5,
// 							py: 0.75,
// 							borderRadius: 2,
// 							bgcolor: `${ACCENT}0F`,
// 							width: "fit-content",
// 						}}
// 					>
// 						<Typography variant="caption" sx={{ color: ACCENT, fontWeight: 600 }}>
// 							{selectedIds.length} Employee(s) selected
// 						</Typography>
// 					</Box>
// 				</Fade>
// 			)}

// 			<DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
// 				<Grid container spacing={3}>
// 					{renderList(firstList, "Eligible Employee(s)", selectedIds, onItemClick, isLoading)}
// 					{renderList(secondList, "Ineligible Employee(s)", selectedIds, onItemClick, isLoading)}
// 				</Grid>
// 			</DragDropContext>
// 		</Box>
// 	);
// };

import { DragDropDDLPanel, IMoveItemsPayload } from "../../DragDropDDLPanel";
import React, { FC } from "react";

import { IDNDList } from "@websential/cosmic-v20";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

export interface IStatutoryHolidayEligibilityPanel {
	firstList: IDNDList;
	secondList: IDNDList;
	onListsChange: (updatedFirstList: IDNDList, updatedSecondList: IDNDList) => void;
	onMoveItems: (payload: IMoveItemsPayload) => void;
	isLoading: boolean;
}

export const StatutoryHolidayEligibilityPanel: FC<IStatutoryHolidayEligibilityPanel> = ({
	firstList,
	secondList,
	onListsChange,
	onMoveItems,
	isLoading,
}) => {
	return (
		<DragDropDDLPanel
			firstList={firstList}
			secondList={secondList}
			firstListConfig={{
				title: "Eligible Employee(s)",
				emptyTitle: "No employees here",
				emptySubtitle: "Drag someone in, or select on the other side",
			}}
			secondListConfig={{
				title: "Ineligible Employee(s)",
				emptyTitle: "No employees here",
				emptySubtitle: "Drag someone in, or select on the other side",
			}}
			itemIcon={<PersonRoundedIcon sx={{ fontSize: 15 }} />}
			onListsChange={onListsChange}
			onMoveItems={onMoveItems}
			isLoading={isLoading}
			accentColor="#0091b3"
			testId="statutory-holiday-eligibility-panel"
		/>
	);
};

export default StatutoryHolidayEligibilityPanel;